<script lang="ts" setup>
    const props = defineProps<{
        points: number;
    }>();
</script>
<template>
    <div class="badge">
        {{ props.points }}
    </div>
</template>
<style lang="scss" scoped>
    @import '~/assets/scss/plp/point-badge.scss';
</style>
